import { AllTranscriptsProps } from '@/types';

interface ConversationsState {
  completedConversations: AllTranscriptsProps[];
  incompleteConversations: AllTranscriptsProps[];
  selectedTranscript: AllTranscriptsProps | null;
  completedTotalPages: number;
  incompleteTotalPages: number;
  setCompletedConversations: (conversations: AllTranscriptsProps[]) => void;
  setIncompleteConversations: (conversations: AllTranscriptsProps[]) => void;
  setSelectedTranscript: (transcript: AllTranscriptsProps | null) => void;
  setCompletedTotalPages: (totalPages: number) => void;
  setIncompleteTotalPages: (totalPages: number) => void;
  getTranscriptById: (id: string) => AllTranscriptsProps | null;
  getPrevTranscript: (
    currentId: string,
    allConversations?: AllTranscriptsProps[],
  ) => AllTranscriptsProps | null;
  getNextTranscript: (
    currentId: string,
    allConversations?: AllTranscriptsProps[],
  ) => AllTranscriptsProps | null;
}

export const completedConversationsSelector = (state: ConversationsState) =>
  state?.completedConversations || [];

export const incompleteConversationsSelector = (state: ConversationsState) =>
  state?.incompleteConversations || [];

export const selectedTranscriptSelector = (state: ConversationsState) => state?.selectedTranscript;

export const completedTotalPagesSelector = (state: ConversationsState) =>
  state?.completedTotalPages || 0;

export const incompleteTotalPagesSelector = (state: ConversationsState) =>
  state?.incompleteTotalPages || 0;

export const conversationsActionsSelector = (state: ConversationsState) => ({
  setCompletedConversations: state.setCompletedConversations,
  setIncompleteConversations: state.setIncompleteConversations,
  setSelectedTranscript: state.setSelectedTranscript,
  setCompletedTotalPages: state.setCompletedTotalPages,
  setIncompleteTotalPages: state.setIncompleteTotalPages,
});

export const conversationsUtilsSelector = (state: ConversationsState) => ({
  getTranscriptById: state.getTranscriptById,
  getPrevTranscript: state.getPrevTranscript,
  getNextTranscript: state.getNextTranscript,
});
